"use strict";

var _slicedToArray = require("/home/gajewsky/code/smooth-ui/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Nav = _interopRequireDefault(require("./Nav"));

var _NavWrapper = _interopRequireDefault(require("./NavWrapper"));

var _NavToggle = _interopRequireDefault(require("./NavToggle"));

var _NavContext = _interopRequireDefault(require("./NavContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}
/* eslint-disable jsx-a11y/accessible-emoji */


function NavHeader(_ref) {
  var variant = _ref.variant,
      children = _ref.children;

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      toggled = _ref3[0],
      _onToggle = _ref3[1];

  return _react["default"].createElement("div", null, _react["default"].createElement(_NavContext["default"].Provider, {
    value: {
      toggled: toggled
    }
  }, _react["default"].createElement(_Nav["default"], {
    variant: variant,
    style: toggled ? {
      position: 'fixed'
    } : null
  }, _react["default"].createElement(_NavWrapper["default"], null, children, _react["default"].createElement(_NavToggle["default"], {
    toggled: toggled,
    onToggle: function onToggle() {
      return _onToggle(function (toggled) {
        return !toggled;
      });
    }
  })))));
}

var _default = NavHeader;
exports["default"] = _default;